export default __webpack_public_path__ + "static/media/icon-card-custom-fields-extras.f3e7e3e1.svg";